export default "__VITE_ASSET__1eP81j7c__"